import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import React from 'react';

const SocialLink = props => <a href={props.link} onClick={props.onClick} target="_blank" className="socials__item" rel="noreferrer">
    <SpriteIcon name={props.svgId} size={{height: 35, width: 35}}/>
</a>;

export default SocialLink;
